import { render } from "./OrdersHosd.vue?vue&type=template&id=1259ad8e&scoped=true"
import script from "./OrdersHosd.vue?vue&type=script&lang=js"
export * from "./OrdersHosd.vue?vue&type=script&lang=js"

import "./OrdersHosd.vue?vue&type=style&index=0&id=1259ad8e&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1259ad8e"]])

export default __exports__